// Der Oelfinder-Störer im Videobanner haengt per "transform: translateY(50%)" zur Haelfte
// unter die Bannerkante (siehe _videoBanner.scss .oelfinder-wrapper) - ein bewusster
// "schwebende Karte"-Effekt. Wie viel Platz er dabei oben (Richtung Hero-Text, der per
// justify-content zentriert ist) und unten (Richtung naechster Block, z.B. tabSlider)
// tatsaechlich braucht, haengt vom Textumbruch ab (variiert je Breite/Sprache/Inhalt).
// Ein rein CSS-basierter Versuch (flex:1 + align-items:center + festes padding-bottom)
// hat sich als nicht zuverlaessig erwiesen: bei "height: fit-content" auf dem Banner hat
// flex:1 keine definierte Restflaeche zum Verteilen, der Text konnte trotzdem in den
// Störer hineinlaufen. Deshalb hier gemessen statt geschaetzt, mit echten
// getBoundingClientRect()-Werten statt CSS-Annahmen:
//   1. Text-vs-Störer (oben): min-height am Banner iterativ erhoehen, bis zwischen
//      .videoBanner__content und .oelfinder-widget ein Mindestabstand steht.
//   2. Störer-vs-naechster-Block (unten): margin-bottom am Banner = halbe Störer-Hoehe
//      + Puffer, damit der folgende Block (z.B. tabSlider) nicht unter den Störer rutscht.
export function initVideoBannerSpacing() {
    const MOBILE_BREAKPOINT = 767; // entspricht $screen-xs-max - dort kein Straddle-Effekt
    const MIN_GAP = 16;
    const MAX_ITERATIONS = 8;

    function apply(banner) {
        const content = banner.querySelector(".videoBanner__content");
        const widget = banner.querySelector(".oelfinder-widget");
        const wrapper = banner.querySelector(".oelfinder-wrapper");
        if (!content || !widget || !wrapper) return;

        if (window.innerWidth <= MOBILE_BREAKPOINT) {
            // Mobile: Störer läuft im normalen Textfluss mit (siehe CSS) - kein
            // Straddle-Effekt, keine Korrektur noetig.
            banner.style.minHeight = "";
            banner.style.marginBottom = "";
            return;
        }

        // Vor der Messung zuruecksetzen, sonst summieren sich alte Korrekturen auf.
        banner.style.minHeight = "";

        for (let i = 0; i < MAX_ITERATIONS; i++) {
            const contentRect = content.getBoundingClientRect();
            const widgetRect = widget.getBoundingClientRect();
            const gap = widgetRect.top - contentRect.bottom;
            if (gap >= MIN_GAP) break;

            const bannerRect = banner.getBoundingClientRect();
            const currentMin = parseFloat(banner.style.minHeight) || bannerRect.height;
            banner.style.minHeight = `${Math.ceil(currentMin + (MIN_GAP - gap) + 4)}px`;
        }

        const half = widget.getBoundingClientRect().height / 2;
        banner.style.marginBottom = `${Math.ceil(half + 8)}px`;
    }

    function run() {
        document.querySelectorAll(".videoBanner").forEach(apply);
    }

    run();

    let resizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(run, 120);
    });
}
